import React from 'react'
import background from "../assets/images/inner-banner.png";

function Innerbanner() {

    const hire_talent_bg={
   
        backgroundImage:`url(${background})`,        
        };

  return (
    <div className="inner_banner" style={hire_talent_bg}>
    <div className="container">
        <div className="inner_banner_content">
          <h1>Talent Profile</h1>
          <ul>
            <li>Hire Talent</li>
            <li>/</li>
             <li>Profile</li>
          </ul>
        </div>
    </div>
   </div>
  )
}

export default Innerbanner